module.exports = __webpack_public_path__ + "img/compliance.6d1bb1f9.png";